// extracted by mini-css-extract-plugin
export default {"link":"DocLink_link__pBCpd","active":"DocLink_active__FSGrb"};